<template>
  <div>
    <h2>Lessons</h2>
    <p>On-line lessons are once a week. I try to tailor lessons to include songs the student really likes.
      I draw material from a variety of sources including new books and hard-to-find ones in my personal library,
      as well as on-line sites. I arrange favorite songs to match each student’s level of proficiency.
      <br/>
    </p>
    <img class="hand-drawn mobile-show" src='../assets/other_kid_at_piano.jpg'/>
    <p>
      <img class="mobile-hide" src='../assets/other_kid_at_piano.jpg'/>
      Each lesson is friendly, meaningful and personal. Students never have to do something they really don’t want to
      do.
      We work together to make their musical experience a positive one, not only expanding their understanding of music,
      but nurturing their appreciation of the learning process in general.
      <br/>
    </p>
    <p>
      My on-line setup includes high quality cameras and sound equipment to insure an easy transfer of musical ideas.
      Students need only a well-placed laptop near their piano.
    </p>
  </div>

</template>

<script>
export default {
  name: "LessonsSection"
}
</script>

<style scoped>

h2 {
  margin-top: 0;
}

img.mobile-hide {
  float: left;
  width: 30%;
  height: 100%;
  margin-right: 20px;
}
</style>